// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-vip[data-v-5c70f5ce]{position:absolute;top:25px;right:39px;z-index:9}", ""]);
// Exports
module.exports = exports;
